import React, { FC } from "react";

import styles from "./download-app-buttons.module.scss";
import { GoogleAppBadgeContainer } from "containers/shared/google-app-badge/google-app-badge-container";
import { IosAppBadgeContainer } from "containers/shared/ios-app-badge/ios-app-badge-container";

export const DownloadAppButtonsContainer: FC = () => {
  return (
    <div className={styles.root}>
      <div className={styles.button}>
        <GoogleAppBadgeContainer />
      </div>
      <div className={styles.button}>
        <IosAppBadgeContainer />
      </div>
    </div>
  );
};
